import { createClient } from '@/shared/api';
import type {
  UpdateStudyReferringPhysicianMutation,
  UpdateStudyReferringPhysicianMutationVariables,
} from '@/shared/api';
import UPDATE_STUDY_REFERRING_PHYSICIAN from '../mutations/updateStudyReferringPhysician';

/**
 * Sets the referring physician on a study. Runs UPDATE_STUDY_REFERRING_PHYSICIAN and throws the returned message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns The updateStudyReferringPhysician payload.
 */
const handleUpdateStudyReferringPhysician = async (
  input: UpdateStudyReferringPhysicianMutationVariables['input'],
): Promise<UpdateStudyReferringPhysicianMutation['updateStudyReferringPhysician']> => {
  const client = createClient();
  const result = await client.mutate<
    UpdateStudyReferringPhysicianMutation,
    UpdateStudyReferringPhysicianMutationVariables
  >({
    mutation: UPDATE_STUDY_REFERRING_PHYSICIAN,
    variables: {
      input,
    },
  });
  const { updateStudyReferringPhysician } = result?.data || {};
  if (!updateStudyReferringPhysician?.isSuccess) {
    throw new Error(updateStudyReferringPhysician?.message ?? undefined);
  }
  return updateStudyReferringPhysician;
};

export default handleUpdateStudyReferringPhysician;
